import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/24x24/EyeDisc2';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
const PremiumIcon = ({ className, premiumFolderData, withTooltip = true, tooltipClassName, size = IconSize.MEDIUM })=>{
    const { t } = useTranslation();
    const { isPremium, isPaidFolder, isWatchToAccess } = normalizePremiumFolderData(premiumFolderData);
    if (!isPremium) {
        return null;
    }
    const icon = isPaidFolder ? /*#__PURE__*/ React.createElement(PremiumGallery, {
        size: size,
        className: className
    }) : isWatchToAccess ? /*#__PURE__*/ React.createElement(EyeDisc2, {
        size: size,
        className: className
    }) : null;
    const transKey = isPaidFolder ? 'deviationview.paywall.thumb.premiumFolder.tooltip' : isWatchToAccess ? 'deviationview.paywall.thumb.watchersOnly.tooltip' : '';
    return withTooltip ? /*#__PURE__*/ React.createElement(SimpleTooltip, {
        text: t(transKey),
        className: tooltipClassName,
        usePortal: true
    }, icon) : icon;
};
PremiumIcon.displayName = 'PremiumIcon';
export default PremiumIcon;

//# sourceMappingURL=PremiumIcon.js.map